import ajax from '@/utils/ajax';

export default {
    listByVessel: params => ajax.post("/api/sailRoute/listByVessel", params),
    listByVesselCurrent: params => ajax.post("/api/sailRoute/listByVesselCurrent", params),
};
